export enum AppStoreKeys {
  User = 'user',
  TrainingPackage = 'trainingpackage',
  ToggleFeatures = 'features',
  TrainingEvents = 'trainingevents',
  TrainingEvent = 'trainingevent',
  TrainingRecords = 'trainingrecords',
  UserSchedule = 'userschedule',
  UserDaySchedule = 'userdayschedule',
  PropertyBagState = 'propertyBagState',
  CourseWareProgress = 'courseWareProgress',
  PrecheckinTraining = 'preCheckinTraining',
  PreCheckinVisitState = 'preCheckinVisit',
  PrecheckinForm = 'preChekinForm',
  PreCheckinCountriesNationalities = 'preCheckinCountriesNationalities',
  PreCheckinVisitDocumentState = 'preCheckinVisitDocumentState',
  PrecheckinSharedState = 'precheckinSharedState',
  PreCheckinFormCustomization = 'preCheckinFormCustomization',
  UserPreference = 'userPreference'
}
